import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  ethnicityRow: {
    gap: 8
  }
})

export default useStyles
